import * as JSURL from 'jsurl2';
export const JsonUrlParam = {
    encode: function (any) {
        if (any == null) {
            return any;
        }
        return JSURL.stringify(any);
    },
    decode: function (input) {
        return JSURL.tryParse(input, undefined);
    },
};
